module.exports = __webpack_public_path__ + "img/JabberLogo.05c28c22.svg";